import z from 'zod';
export const accountingCategoryWithChildren = {
    include: {
        children: true,
    },
};
export const accountingCategoryDataSchema = z.object({
    name: z.string().min(1, 'Le nom est requis'),
    parentId: z.number().int().nullable().optional(),
});
